module.exports = __webpack_public_path__ + "img/13.7bf4c149.png";